import React from 'react'
import {connect} from 'react-redux'
import _ from 'lodash'
import orderBy from 'lodash/sortBy'
import {is_config_complete} from '../util'
import {load_pulls} from '../state/action_creators'
import {LOADING, INITIAL, ERROR} from '../state/pulls_reducer'
import PullRequest from './PullRequest'
import User from './User'

class PullRequestList extends React.PureComponent {
  load_pulls() {
    return this.props.load_pulls(this.props.config)
  }

  render() {
    const {pulls, status, error, config} = this.props

    if (!is_config_complete(config)) {
      return <div>Config is not complete</div>
    }

    if (status === INITIAL && is_config_complete(config)) {
      this.load_pulls()
    }

    if (status === ERROR) {
      return <div>Error: {error.message}</div>
    }

    if ([LOADING, INITIAL].includes(status)) {
      return <div>Loading...</div>
    }

    const pulls_by_number = {}
    const reviewers = {}
    const pulls_by_updated = orderBy(pulls, ['created_at'], ['asc'])
    for (const pull of pulls_by_updated) {
      pulls_by_number[pull.number] = pull
      for (const reviewer of pull.requested_reviewers) {
        if (!_.has(reviewers, reviewer.login)) {
          reviewers[reviewer.login] = {
            ...reviewer,
            review_count: 0,
            pr_numbers: [],
          }
        }
        reviewers[reviewer.login].review_count += 1
        reviewers[reviewer.login].pr_numbers.push(pull.number)
      }
    }

    const sorted_reviewers = _.orderBy(Object.values(reviewers), ['review_count'], ['desc'])
    // console.log(pulls.map((p) => p.title).join('\n'))

    return (
      <div className='pulls'>
        <button onClick={() => this.load_pulls()}>Refresh</button>
        <h1>Review Counts</h1>
        <ul>
          {sorted_reviewers.map((reviewer) => (
            <li key={reviewer.login}><User user={reviewer} url={`#${reviewer.login}`}/> ({reviewer.review_count})</li>
          ))}
        </ul>
        <h1>Pull Requests</h1>
        {pulls_by_updated.map((pull) => <PullRequest pull={pull} key={pull.number} />)}
        <h1>By Reviewer</h1>
        {sorted_reviewers.map((reviewer) => {
          return (
            <div id={reviewer.login} key={reviewer.login}>
              <h2>{reviewer.login}</h2>
              {reviewer.pr_numbers
                .map((pr_number) => {
                  const pull = pulls_by_number[pr_number]
                  const key = `${reviewer.login}_${pr_number}`
                  return <PullRequest pull={pull} key={key} />
                })
              }
            </div>
          )
        })}
      </div>
    )
  }
}

const state_to_props = state => ({
  status: state.pulls.status,
  pulls: state.pulls.pulls,
  error: state.pulls.error,
  config: state.config,
})

export default connect(state_to_props, {load_pulls})(PullRequestList)
